// Load configuration data (items config, positions config) - MUST be first
// This populates GlobalState with data needed by all other modules
import '@/scripts/config/init'

import '@/styles/index.scss'
import appModeController from '@/scripts/appModeController'
import analytics from '@/scripts/analytics'
import audioManager from '@/scripts/audio/audioManager'
import buttons from '@/scripts/ui/buttons'

init()

function init(): void {
  // Tracks user interactions (activity views, clicks, etc.)
  // - Integrates with DP analytics system
  // - Auto-tracks elements with data-track-id attributes
  analytics.init()

  // Handles all audio playback
  audioManager.init()

  // Manages UI button interactions
  buttons.init()

  // Detects desktop vs mobile and boots appropriate mode
  // - Handles window resize/orientation changes
  // - Manages scene parking/resuming when switching modes
  appModeController.init()
}
